import { css } from '@emotion/react'
import { Text, Theme, useTheme, VFlow } from 'bold-ui'
import { ReactComponent as AvisoDadosSensiveisIcon } from 'images/cidadao/aviso-cidadao-dados-sensiveis.svg'

export function AvisoDadosSensiveisCard() {
  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <div css={styles.container} data-testid='aviso-dados-sensiveis-card'>
      <AvisoDadosSensiveisIcon css={styles.image} />
      <VFlow vSpacing={0.4} style={styles.content}>
        <Text fontWeight='bold' style={styles.title}>
          Tenha cuidado ao coletar dados sensíveis!
        </Text>
        <Text>
          Este cadastro pode envolver perguntas sobre aspectos pessoais e sensíveis da vida da pessoa cadastrada. Sempre
          que possível, realize a coleta em um ambiente acolhedor e com privacidade, assegurando escuta qualificada,
          respeito e confidencialidade no tratamento das informações.
        </Text>
      </VFlow>
    </div>
  )
}

const createStyles = (theme: Theme) => ({
  container: css`
    display: flex;
    align-items: center;
    gap: 1rem;
    flex-wrap: wrap;
    padding: 1rem 1.5rem;
    outline: 1px solid ${theme.pallete.gray.c60};
    background-color: ${theme.pallete.surface.main};
    border-radius: 0.5rem;
  `,
  content: css`
    flex: 1;
    min-width: 16rem;
  `,
  title: css`
    color: ${theme.pallete.primary.main};
    font-size: 1.125rem;
  `,
  image: css`
    width: 9rem;
    min-width: 9rem;
    height: auto;
    flex-shrink: 0;
  `,
})
